import { render, staticRenderFns } from "./LearningStep.vue?vue&type=template&id=dd804670&scoped=true"
import script from "./LearningStep.vue?vue&type=script&lang=js"
export * from "./LearningStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd804670",
  null
  
)

export default component.exports